import { useCallback } from 'react';
import { useSettingsOpcional } from '../context/SettingsContext';
import { idiomaActual, traducir, type Vars } from './index';
import type { Idioma } from './idiomas';

/**
 * Hook de traducción. Al leer el idioma del `SettingsContext`, cualquier cambio en el
 * selector vuelve a renderizar los componentes que usan `t` sin recargar la página.
 *
 * Sin provider por encima (componentes aislados en pruebas) cae al idioma activo de
 * módulo en lugar de lanzar.
 */
export function useT() {
    const ajustes = useSettingsOpcional();
    const idioma = ajustes?.language ?? idiomaActual();
    return useCallback((clave: string, vars?: Vars) => traducir(idioma, clave, vars), [idioma]);
}

/** Idioma activo, suscrito al contexto de ajustes. Para pasar a helpers de módulo. */
export function useIdioma(): Idioma {
    const ajustes = useSettingsOpcional();
    return ajustes?.language ?? idiomaActual();
}
